import React, { Component } from "react";
import httpService from "../../services/httpService";
import config from "../../config.json";
import { Button } from "react-bootstrap";
import HledatOsobu from "../common/HledatOsobu";

class UzivatelDetail extends Component {
  state = { user: {} };

  componentDidMount = () => {
    this.nahrajUzivatele();
  };

  componentDidUpdate = () => {
    const { login } = this.state;
    if (login && login !== this.props.login) {
      this.nahrajUzivatele();
    }
  };

  nahrajUzivatele = async () => {
    const { login } = this.props;
    const user = await httpService.post(
      config.apiEndpoint + "user/detail.php",
      { login }
    );
    this.setState({
      login,
      user: user.data.uzivatel,
      duvodNepritomnosti: user.data.duvodNepritomnosti,
      pojistovny: user.data.zdravotniPojistovna,
      vakcina: user.data.vakcina,
    });
  };

  userChangeDetail = async (login, attr, val, save) => {
    let { user } = this.state;
    const { onChange } = this.props;
    user[attr] = val;
    this.setState({ user });
    if (save === true) {
      await httpService.post(config.apiEndpoint + "uzivatele/zmenaDetail.php", {
        login,
        attr,
        val,
      });
      if (onChange) {
        onChange();
      }
    }
  };

  novaDavka = async () => {
    const { datum, vakcina_id } = this.state;
    let { user, uzivatele } = this.state;
    user.ockovani.push({ datum, vakcina_id });
    this.setState({ user, datum: null });
    await httpService.post(config.apiEndpoint + "covid/novaDavka.php", {
      login: user.login,
      datum,
      vakcina_id,
    });
    this.nahrajUzivatele();
  };

  zmenaVakcinace = async (login, datum, attr, val) => {
    let { user, uzivatele } = this.state;
    if (attr === "del") {
      if (val === true) {
        user.ockovani = user.ockovani.filter((o) => o.datum !== datum);
      } else {
        if (window.confirm("Urcite smazat?")) {
          this.zmenaVakcinace(login, datum, attr, true);
        }
        return false;
      }
    } else {
      user.ockovani.find((o) => o.datum === datum)[attr] = val;
    }
    this.setState({ user });
    await httpService.post(config.apiEndpoint + "covid/zmenaVakcinace.php", {
      login,
      datum,
      attr,
      val,
    });
    this.nahrajUzivatele();
  };

  render() {
    const {
      user,
      pojistovny,
      duvodNepritomnosti,
      zamestnavatele,
      systemizace,
      pracoviste,
      vakcina,
      datum,
      vakcina_id,
    } = this.state;
    return (
      <React.Fragment>
        {user && (
          <React.Fragment>
            <div className="row">
              <div className="col-md-6">
                <div className="row">
                  <div className="col-md-4">
                    <small>Jméno</small>
                    <input
                      className="form-control"
                      type="text"
                      name="jmeno"
                      value={user.jmeno}
                      onChange={(e) =>
                        this.userChangeDetail(
                          user.login,
                          e.target.name,
                          e.target.value,
                          false
                        )
                      }
                      onBlur={(e) =>
                        this.userChangeDetail(
                          user.login,
                          e.target.name,
                          e.target.value,
                          true
                        )
                      }
                    />
                  </div>
                  <div className="col-md-4">
                    <HledatOsobu
                      value={user.nadrizenyJmeno}
                      title="Nadřízený"
                      onSelect={(login, jmeno) => {
                        this.userChangeDetail(
                          user.login,
                          "nadrizenyLogin",
                          login,
                          true
                        );
                        this.userChangeDetail(
                          user.login,
                          "nadrizenyJmeno",
                          jmeno,
                          true
                        );
                      }}
                    />
                  </div>
                  <div className="col-md-4">
                    <small>Zaměstnavatel/Místo</small>
                    <select
                      name="firma_id"
                      value={user.firma_id}
                      className="form-control"
                      onChange={(e) =>
                        this.userChangeDetail(
                          user.login,
                          e.target.name,
                          e.target.value,
                          true
                        )
                      }
                    >
                      <option value="">Nezařazen</option>
                      {zamestnavatele &&
                        zamestnavatele.length > 0 &&
                        zamestnavatele.map((f) => (
                          <option value={f.firma_id} key={f.firma_id}>
                            {f.nazev}
                          </option>
                        ))}
                    </select>
                  </div>
                  <div className="col-md-4">
                    <small>Mobil (bez mezer vč. +420)</small>
                    <input
                      className="form-control"
                      type="text"
                      name="mobil"
                      value={user.mobil}
                      onChange={(e) =>
                        this.userChangeDetail(
                          user.login,
                          e.target.name,
                          e.target.value,
                          false
                        )
                      }
                      onBlur={(e) =>
                        this.userChangeDetail(
                          user.login,
                          e.target.name,
                          e.target.value,
                          true
                        )
                      }
                    />
                  </div>
                  <div className="col-md-6">
                    <small>Nepřítomnost</small>
                    <select
                      name="nepritomen"
                      className="form-control"
                      value={user.nepritomen}
                      onChange={(e) =>
                        this.userChangeDetail(
                          user.login,
                          e.target.name,
                          e.target.value,
                          true
                        )
                      }
                    >
                      {duvodNepritomnosti &&
                        duvodNepritomnosti.map((d) => (
                          <option value={d.duvod_id} key={d.duvod_id}>
                            {d.nazev}
                          </option>
                        ))}
                    </select>
                  </div>
                  <div className="col-md-6">
                    <small>Ulice</small>
                    <input
                      className="form-control"
                      type="text"
                      name="ulice"
                      value={user.ulice}
                      onChange={(e) =>
                        this.userChangeDetail(
                          user.login,
                          e.target.name,
                          e.target.value,
                          false
                        )
                      }
                      onBlur={(e) =>
                        this.userChangeDetail(
                          user.login,
                          e.target.name,
                          e.target.value,
                          true
                        )
                      }
                    />
                  </div>
                  <div className="col-md-6">
                    <small>Město</small>
                    <input
                      className="form-control"
                      type="text"
                      name="mesto"
                      value={user.mesto}
                      onChange={(e) =>
                        this.userChangeDetail(
                          user.login,
                          e.target.name,
                          e.target.value,
                          false
                        )
                      }
                      onBlur={(e) =>
                        this.userChangeDetail(
                          user.login,
                          e.target.name,
                          e.target.value,
                          true
                        )
                      }
                    />
                  </div>
                  <div className="col-md-6">
                    <small>PSČ</small>
                    <input
                      className="form-control"
                      type="text"
                      name="psc"
                      value={user.psc}
                      onChange={(e) =>
                        this.userChangeDetail(
                          user.login,
                          e.target.name,
                          e.target.value,
                          false
                        )
                      }
                      onBlur={(e) =>
                        this.userChangeDetail(
                          user.login,
                          e.target.name,
                          e.target.value,
                          true
                        )
                      }
                    />
                  </div>
                  <div className="col-md-6">
                    <small>Státní příslušnost</small>
                    <input
                      className="form-control"
                      type="text"
                      name="statniPrislusnost"
                      value={user.statniPrislusnost}
                      onChange={(e) =>
                        this.userChangeDetail(
                          user.login,
                          e.target.name,
                          e.target.value,
                          false
                        )
                      }
                      onBlur={(e) =>
                        this.userChangeDetail(
                          user.login,
                          e.target.name,
                          e.target.value,
                          true
                        )
                      }
                    />
                  </div>
                  <div className="col-md-4">
                    <small>Ukončení prac. poměru</small>
                    <input
                      type="date"
                      name="ukonceniPomeru"
                      className="form-control"
                      value={user.ukonceniPomeru}
                      onChange={(e) =>
                        this.userChangeDetail(
                          user.login,
                          e.target.name,
                          e.target.value,
                          false
                        )
                      }
                      onBlur={(e) =>
                        this.userChangeDetail(
                          user.login,
                          e.target.name,
                          e.target.value,
                          true
                        )
                      }
                    />
                  </div>
                  <div className="col-md-4">
                    <small>Covid pozitivní</small>
                    <input
                      type="date"
                      name="covidPozitivni"
                      className="form-control"
                      value={user.covidPozitivni}
                      onChange={(e) =>
                        this.userChangeDetail(
                          user.login,
                          e.target.name,
                          e.target.value,
                          false
                        )
                      }
                      onBlur={(e) =>
                        this.userChangeDetail(
                          user.login,
                          e.target.name,
                          e.target.value,
                          true
                        )
                      }
                    />
                  </div>
                  <div className="col-md-4">
                    <small>GDPR souhlas</small>
                    <input
                      type="date"
                      name="gdprSouhlas"
                      className="form-control"
                      value={user.gdprSouhlas}
                      onChange={(e) =>
                        this.userChangeDetail(
                          user.login,
                          e.target.name,
                          e.target.value,
                          false
                        )
                      }
                      onBlur={(e) =>
                        this.userChangeDetail(
                          user.login,
                          e.target.name,
                          e.target.value,
                          true
                        )
                      }
                    />
                  </div>{" "}
                </div>
              </div>
              <div className="col-md-6">
                <h4>Vakcinace</h4>
                <div className="row">
                  {user.ockovani &&
                    user.ockovani.map((o) => (
                      <div
                        className="col-md-12"
                        key={o.datum}
                        style={{
                          borderTop: "solid 1px #ddd",
                          paddingTop: "10px",
                          paddingBottom: "10px",
                        }}
                      >
                        <div className="row">
                          <div className="col-5">
                            <small>Datum</small>
                            <input
                              type="date"
                              className="form-control"
                              name="datum"
                              value={o.datum}
                              onChange={(e) =>
                                this.zmenaVakcinace(
                                  user.login,
                                  o.datum,
                                  e.target.name,
                                  e.target.value
                                )
                              }
                            />
                          </div>
                          <div className="col-5">
                            <small>Vakcína</small>
                            <select
                              name="vakcina_id"
                              className="form-control"
                              value={o.vakcina_id}
                              onChange={(e) =>
                                this.zmenaVakcinace(
                                  user.login,
                                  o.datum,
                                  e.target.name,
                                  e.target.value
                                )
                              }
                            >
                              {vakcina &&
                                vakcina.map((v) => (
                                  <option
                                    value={v.vakcina_id}
                                    key={v.vakcina_id}
                                  >
                                    {v.nazev}, {v.vyrobce}
                                  </option>
                                ))}
                            </select>
                          </div>
                          <div className="col-2">
                            <button
                              className="btn btn-danger"
                              style={{ marginTop: "20px" }}
                              onClick={() =>
                                this.zmenaVakcinace(
                                  user.login,
                                  o.datum,
                                  "del",
                                  false
                                )
                              }
                            >
                              DEL
                            </button>
                          </div>
                          {o.upravil_jmeno && o.upravil_jmeno !== "" && (
                            <div className="col-12">
                              <small>
                                {o.upravil_jmeno} | {o.upravil_datum}
                              </small>
                            </div>
                          )}
                        </div>
                      </div>
                    ))}
                  <div
                    className="col-md-12"
                    style={{
                      borderTop: "solid 1px #ddd",
                      paddingTop: "10px",
                      paddingBottom: "10px",
                    }}
                  >
                    <div className="row">
                      <div className="col-5">
                        <small>Nové datum vakcinace</small>
                        <input
                          type="date"
                          className="form-control"
                          name="datum"
                          value={datum}
                          onChange={(e) =>
                            this.setState({
                              [e.target.name]: e.target.value,
                            })
                          }
                        />
                      </div>
                      <div className="col-5">
                        <small>Vakcína</small>
                        <select
                          name="vakcina_id"
                          className="form-control"
                          value={vakcina_id}
                          onChange={(e) =>
                            this.setState({
                              [e.target.name]: e.target.value,
                            })
                          }
                        >
                          {vakcina &&
                            vakcina.map((v) => (
                              <option value={v.vakcina_id} key={v.vakcina_id}>
                                {v.nazev}, {v.vyrobce}
                              </option>
                            ))}
                        </select>
                      </div>
                      <div className="col-2">
                        <button
                          className="btn btn-success"
                          style={{ marginTop: "20px" }}
                          disabled={!datum}
                          onClick={this.novaDavka}
                        >
                          Přidat
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

export default UzivatelDetail;
